import { render, staticRenderFns } from "./EvaluationPage.vue?vue&type=template&id=b1a8a064&scoped=true"
import script from "./EvaluationPage.vue?vue&type=script&lang=js"
export * from "./EvaluationPage.vue?vue&type=script&lang=js"
import style0 from "./EvaluationPage.vue?vue&type=style&index=0&id=b1a8a064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8a064",
  null
  
)

export default component.exports